import axiosHttp from "./interceptor.service";

const postProject = (data) => {
  return axiosHttp.post("/feedback/createProject", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getProject = ({ page, limit, sort, search, month } = {}) => {
  return axiosHttp.get("/feedback/getProject", {
    params: { page, limit, sort, search, month },
  });
};
const getProjectCron = ({ page, limit, sort, search } = {}) => {
  return axiosHttp.get("/feedback/getProjectCron", {
    params: { page, limit, sort, search },
  });
};

const getTransactionPending = ({ page, search, limit, sort, month, startDate, endDate } = {}) => {
  return axiosHttp.get("/feedback/getTranPending", {
    params: { page, search, limit, sort, month, startDate, endDate},
  });
};

const updateProject = (id, data) => {
  return axiosHttp.put(`/feedback/updateProject/${id}`, data);
};

const deleteProject = (id) => {
  return axiosHttp.delete(`/feedback/deleteProject/${id}`);
};

export {
  postProject,
  getProject,
  getProjectCron,
  getTransactionPending,
  updateProject,
  deleteProject,
};
